<template>
  <div>
    <modal @closed="closeModal" class="modal" name="createRoomModal" :width="770" height="auto" :adaptive="true" :scrollable="true" style="z-index:1000">
      <button @click="closeModal" class="absolute right-0 m-3">
        <img src="@/assets/img/close.svg" alt="Close">
      </button>
      <div class="mt-10 mx-auto w-max">
        <h2>Ruimte toevoegen</h2>
      </div>

      <div v-if="!roomType" class="w-full">
        <div class="text-center mt-4">Kies een kamer type</div>

        <div class="w-full p-4 flex flex-row flex-wrap justify-between mt-2">
          <div
            v-for="(type) of roomTypes" :key="type"
            @click="roomType = type"
            class="shadow p-4 m-2 w-1/4 h-full flex-grow flex-col flex cursor-pointer items-center content-center"
          >
            <img :src="getIcon(type)" class="w-12 h-12"/>
            <p class="font-thin text-gray-800 capitalize">{{ type.replace('-', ' ') }}</p>
          </div>
        </div>
      </div>

      <div v-if="roomType">
        <div class="text-center mt-4">Kies een naam voor deze kamer</div>
        <div class="flex justify-center">
          <div class="flex items-center mt-2">
            <img :src="getIcon(roomType)" class="w-8 h-8">
            <p class="text-gray-800 capitalize ml-2">{{ roomType.replace('-', ' ') }}</p>
          </div>
        </div>
        <formulate-form ref="locationForm" name="locationForm" v-model="formValues" @submit="createRoom()" class="mb-6 mt-2">
        <div class="container">
          <formulate-input validation="required" error-behavior="submit" type="text" name="type" hidden v-model="roomType"></formulate-input>
          <formulate-input validation="required" error-behavior="submit" type="text" name="name" label="Naam"></formulate-input>
          <formulate-input type="submit" :label="$t('Bevestigen')" class="bg-wilmsBlue w-max text-white rounded-sm p-2"/>
        </div>
      </formulate-form>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: ['open'],
  data () {
    return {
      formValues: {},
      roomType: null,
      roomTypes: []
    }
  },
  mounted () {
    this.roomTypes = this.$store.getters['RoomsModule/getRoomTypes']
  },
  methods: {
    closeModal () {
      this.roomType = null
      this.$modal.hide('createRoomModal')
      this.$emit('close')
    },
    openModal () {
      this.$modal.show('createRoomModal')
    },
    async createRoom () {
      await this.$store.dispatch('RoomsModule/createRoom', {
        homeId: this.$route.params.home,
        room: this.formValues
      })
      this.$emit('close')
    },
    getIcon (roomType) {
      return require(`@/assets/img/iot/room-icons/${roomType}.svg`)
    }
  },
  watch: {
    open () {
      if (this.open) {
        this.openModal()
      } else {
        this.closeModal()
      }
    }
  }
}
</script>
